module.exports = __webpack_public_path__ + "img/playlist-share.68883da3.svg";